import { FC } from 'react';
import styled from 'styled-components';
import { Flex } from '@summer/react-kit';
import { IntlFormattedMessage } from 'src/common/components/IntlFormattedMessage';

const LisItem = styled.li`
  display: flex;
  flex-direction: column;
`;

const Number = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.625rem;
  line-height: 0.625rem;
  background-color: ${({ theme }) => theme.text.primary};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.white};
  margin-right: 1rem;
  flex-shrink: 0;
`;

const Separator = styled.span`
  width: 0.125rem;
  height: 1rem;
  background: ${({ theme }) => theme.colors.catskillWhite};
  border-radius: 0.0625rem;
  margin: 0.25rem 0.5rem;
`;

const Text = styled.span`
  color: ${({ theme }) => theme.text.primary};
`;

const List = styled.ol`
  max-width: 31.25rem;
`;

const MainPageStepsList: FC<{ items: MessageId[] }> = ({ items }) => {
  return (
    <List>
      {items.map((x, i) => (
        <LisItem key={x}>
          <Flex alignCenter>
            <Number>{i + 1}</Number>
            <Text>
              <IntlFormattedMessage id={x} />
            </Text>
          </Flex>
          {i + 1 < items.length ? <Separator /> : null}
        </LisItem>
      ))}
    </List>
  );
};

export default MainPageStepsList;
